import { render, staticRenderFns } from "./BasicDemo.vue?vue&type=template&id=c8a3ca26&scoped=true"
import script from "./BasicDemo.vue?vue&type=script&lang=js"
export * from "./BasicDemo.vue?vue&type=script&lang=js"
import style0 from "./BasicDemo.vue?vue&type=style&index=0&id=c8a3ca26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a3ca26",
  null
  
)

export default component.exports